import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanDeactivate,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { UnsavedDataDialogComponent } from '@elight/client/shared/ui/common';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { AbstractBaseEditFormComponent } from '@elight/client/shared/feature/common';

import { ClientSharedUtilityStateModule } from './state.module';

@Injectable({
    providedIn: ClientSharedUtilityStateModule,
})
export class UnsavedChangesGuard
    implements CanDeactivate<AbstractBaseEditFormComponent<any>> {
    constructor(private dialog: MatDialog) {}

    canDeactivate(
        component: AbstractBaseEditFormComponent<any>,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (component.formSubmitted) {
            return of(true);
        }

        const hasChanges = !!component?.changes?.length;

        if (!hasChanges) {
            return of(true);
        }

        const dialogRef = this.dialog.open(UnsavedDataDialogComponent, {
            width: '440px',
        });

        return dialogRef.afterClosed();
    }
}
